export default {
  /* eslint-disable arrow-body-style */
  safeboxUsersFilter: (state) => (filter) => {
    return state.users.filter((user) => {
      const fullName = `${user.firstName} ${user.lastName}`;
      return fullName.toUpperCase().includes(filter.toUpperCase());
    });
  },
};
